import { useEffect } from 'react';

/**
 * @author @buunsal
 * @param {React.RefObject} ref - The ref of the element to be draggable
 * @returns {void}
 * @description useDraggable is a hook that is used to make an element draggable
 * @see https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_draggable
 * @example
 * const ref = useRef();
 * useDraggable(ref);
 * <div ref={ref}>Draggable element</div>
 */
const useDraggable = (ref) => {
	let pos1 = 0,
		pos2 = 0,
		pos3 = 0,
		pos4 = 0;
	const element = ref?.current || ref;

	useEffect(() => {
		if (element) {
			element.style.cursor = 'move';
			element.onmousedown = handleMouseDown;
			element.onmouseup = () => {
				element.style.cursor = 'default';
			};
		}
	}, [ref]);

	const handleMouseDown = (event) => {
		element.style.cursor = 'grabbing';
		const e = event || window.event;
		e.preventDefault();
		// get the mouse cursor position at startup:
		pos3 = e.clientX;
		pos4 = e.clientY;
		document.onmouseup = handleCloseElement;
		// call a function whenever the cursor moves:
		document.onmousemove = handleElementDrag;
	};

	const handleElementDrag = (event) => {
		const e = event || window.event;
		e.preventDefault();

		// calculate the new cursor position:
		pos1 = pos3 - e.clientX;
		pos2 = pos4 - e.clientY;
		pos3 = e.clientX;
		pos4 = e.clientY;

		// set the element's new position:
		element.style.top = `${element.offsetTop - pos2}px`;
		element.style.left = `${element.offsetLeft - pos1}px`;
	};

	const handleCloseElement = () => {
		element.style.cursor = 'move';
		/* stop moving when mouse button is released:*/
		document.onmouseup = null;
		document.onmousemove = null;
	};
};
export default useDraggable;
